import React from "react";
import TextInput from "../components/TextInput";
import ReactSelect, { components } from "react-select";
import ChevronDown from "../assets/img/chevron-down.svg";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={ChevronDown} alt="chevron down" />
    </components.DropdownIndicator>
  );
};

const Placeholder = (props) => {
  return (
    <components.Placeholder className="select-placeholder" {...props}>
      {props.children}
    </components.Placeholder>
  );
};

const SelectText = ({
  placeholderText,
  selectPlaceholder,
  setSelectedOption,
  options,
  breaksInMobile,
  handleTextChange
}) => {
  return (
    <div className={`select-input ${breaksInMobile ? "breaks" : ""}`}>
      <ReactSelect
        options={options}
        onChange={setSelectedOption}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: "none",
            borderRadius: "0",
            outline: "none",
            borderBottom: state.isFocused
              ? "2px solid #424242"
              : "1px solid var(--Gray-dark, #424242);",
            color: "var(--Gray-medium-light, #A2A2A2)",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "20px" /* 125% */,
            letterSpacing: "0.5px",
            height: "44px",
            position: "relative",
            width: breaksInMobile
              ? window.innerWidth > 768
                ? "200px"
                : "100%"
              : "160px",
            cursor: "pointer",
            boxShadow: "none",
            transition: "all 0.3s ease-in-out",
            display: "flex",
            alignItems: "center",
            "&:hover": {
              border: "none",
              borderBottom: "1px solid #424242",
            },
          }),
          indicatorSeparator: (base) => ({
            ...base,
            display: "none",
          }),
          dropdownIndicator: (base, state) => ({
            ...base,
            color: "#424242",
            transform: state.isFocused ? "rotate(180deg)" : "none",
            transition: "all 0.3s ease-in-out",
          }),
          placeholder: (base, state) => ({
            ...base,
            position: "absolute",
            transition: "all 0.3s ease-in-out",
            top: state.isFocused ? "-25px" : "3px",
            left: state.isFocused ? "0" : "8px",
            gridArea: "1",
            display: "flex",
            gap: "8px",
            alignItems: "center",
          }),
        }}
        placeholder={selectPlaceholder}
        components={{ DropdownIndicator, Placeholder }}
      />
      <TextInput placeholder={placeholderText} className={"select-ti"} onChange={handleTextChange}/>
    </div>
  );
};

export default SelectText;
